import styled from "styled-components";

export const Container = styled.div`
  top: 0;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 10px 12px;
  margin: 20px 0;

  @media (min-width: 768px) {
    padding: 0;
    margin: 22px 0;
    gap: 8px 10px;
  }

  .checked{
    background: #DBC7B8;
    color: #424242
  }
  
`;

export const InputLabel = styled.label`
  font-weight: 500;
  font-size: 1.2rem;
  color: ${(props) => props.theme.colors.typography1.pure};
  display: flex;
  align-items: center;
  gap: 25px;
  line-height: 35px;

  @media (min-width: 480px) {
    font-size: 1.75rem;
  }

  @media (min-width: 768px) {
    gap: 9px;
    font-size: 0.875rem;
    line-height: 27px;
  }
`;

export const Button = styled.button`
  height: 20px;
  border: 1px solid ${(props) => props.theme.colors.neutral1.light};
  border-radius: 30px;
  min-width: 60px;
  font-weight: 300;
  color: ${(props) => props.theme.colors.neutral1.light};
  padding: 16px 10px;
  text-transform: lowercase;
  font-size: 0.9rem;
  background: transparent;

  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    height: 15px;
    padding: 16px;
  }
`;

export const CheckboxDiv = styled.input`
  height: 20px;
  border: 1px solid ${(props) => props.theme.colors.neutral1.light};
  border-radius: 30px;
  min-width: 60px;
  font-weight: 300;
  color: ${(props) => props.theme.colors.neutral1.light};
  padding: 16px 10px;
  text-transform: lowercase;
  font-size: 0.9rem;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    height: 15px;
    padding: 16px;
  }
`;